
import React from 'react';
import HCaptcha from '@hcaptcha/react-hcaptcha';

interface CaptchaComponentProps {
  onVerify: (token: string) => void;
  captchaRef: React.RefObject<HCaptcha>;
  error?: string;
}

const CaptchaComponent: React.FC<CaptchaComponentProps> = ({ onVerify, captchaRef, error }) => {
  // Get the site key from environment or use a default for development
  const HCAPTCHA_SITE_KEY = import.meta.env.VITE_HCAPTCHA_SITE_KEY || '10000000-ffff-ffff-ffff-000000000001';

  return (
    <div className="mt-4 mb-6">
      <HCaptcha
        sitekey={HCAPTCHA_SITE_KEY}
        onVerify={onVerify}
        ref={captchaRef}
      />
      {error && (
        <p className="text-sm text-red-500 mt-1">{error}</p>
      )}
    </div>
  );
};

export default CaptchaComponent;
